export default __webpack_public_path__ + "static/media/discord.b048131a.svg";